module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addTask":"Add Task","updateError":"Error updating Task","deleteError":"Error deleting Task"},"fr":{"addTask":"Ajouter une tâche","updateError":"Erreur de mise à jour de la tâche","deleteError":"Erreur de suppression de la tâche"}}')
  delete Component.options._Ctor
}
